import React from 'react';
import heroImage from '../assets/hero-farzeen.png';

const HeroSection = () => {
  return (
    <section className="min-h-screen relative overflow-hidden" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Full Background Image - Positioned Right */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Fade gradient from left - smooth transition */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to right, #0a0a0a 0%, #0a0a0a 30%, transparent 70%, transparent 100%)'
        }}
      />
      
      {/* Additional subtle overlay for text readability */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to right, rgba(10, 10, 10, 0.3) 0%, rgba(10, 10, 10, 0.1) 50%, transparent 70%)'
        }}
      />
      
      {/* Content - Left Aligned */}
      <div className="relative z-10 container mx-auto px-8 min-h-screen flex items-center">
        <div className="max-w-xl">
          <p 
            className="text-xs tracking-[0.4em] mb-6 font-light uppercase"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            Digital Marketing & Branding
          </p>
          
          <h1 
            className="text-2xl md:text-3xl lg:text-4xl font-extralight tracking-[0.15em] leading-[1.4] mb-8 uppercase"
            style={{ color: '#ffffff', fontFamily: "'Playfair Display', serif", letterSpacing: '0.2em' }}
          >
            Break Free &
            <br />
            <span className="italic font-light">Build Online.</span>
          </h1>
          
          {/* Description text */}
          <p 
            className="text-base font-light leading-relaxed mb-10"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            Whether you're breaking free from toxic cycles, starting over, leaving the 9–5, or building something of your own — this is the complete blueprint to building a freedom-based online business.
          </p>
          
          <a 
            href="https://stan.store/FarzeenDigitalWealth/p/digital-wealth-academy--1sj4lwda" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center text-xs tracking-[0.2em] px-10 py-4 transition-all duration-300 hover:bg-white hover:text-black border"
            style={{ backgroundColor: 'transparent', color: '#ffffff', borderColor: 'rgba(255,255,255,0.3)' }}
          >
            START YOUR JOURNEY
          </a>
          
          <p 
            className="text-xs tracking-[0.1em] mt-4 font-light italic"
            style={{ color: 'rgba(255,255,255,0.5)' }}
          >
            Begin with clarity. Build with intention.
          </p>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-8 z-10">
        <div className="flex flex-col items-center gap-2">
          <span className="text-[10px] tracking-[0.2em] uppercase" style={{ color: 'rgba(255,255,255,0.4)' }}>Scroll</span>
          <div className="w-px h-8" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
